var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 40031"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.82898 17.3935L2.78195 19.0396C2.97997 19.3861 3.26462 19.6584 3.59878 19.8564L7.00224 13.9653H0.195312C0.195312 14.349 0.294322 14.7327 0.492342 15.0792L1.82898 17.3935Z",
    fill: "#16162C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.9998 7.03464L7.5963 1.14355C7.26214 1.34157 6.97749 1.61385 6.77947 1.96039L0.492342 12.8515C0.297964 13.1905 0.195571 13.5745 0.195312 13.9653H7.00224L10.9998 7.03464Z",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.401 19.8564C18.7352 19.6584 19.0198 19.3861 19.2179 19.0396L19.6139 18.3589L21.5075 15.0792C21.7055 14.7327 21.8045 14.349 21.8045 13.9653H14.9971L16.4456 16.8119L18.401 19.8564Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.0001 7.0348L14.4036 1.14371C14.0695 0.94569 13.6858 0.84668 13.2897 0.84668H8.71054C8.3145 0.84668 7.93084 0.958066 7.59668 1.14371L11.0001 7.0348Z",
    fill: "#00832D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M14.9971 13.9653H7.0021L3.59863 19.8564C3.93279 20.0544 4.31645 20.1535 4.71249 20.1535H17.2868C17.6828 20.1535 18.0665 20.0421 18.4006 19.8564L14.9971 13.9653Z",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M18.3639 7.40593L15.2203 1.96039C15.0223 1.61385 14.7376 1.34157 14.4035 1.14355L11 7.03464L14.9975 13.9653H21.7921C21.7921 13.5817 21.6931 13.198 21.495 12.8515L18.3639 7.40593Z",
    fill: "#FFBA00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrive);
export default __webpack_public_path__ + "static/media/drive.d52922150429ca5b7bfcf49c3394a443.svg";
export { ForwardRef as ReactComponent };